//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  maxLength,
  minLength,
  required,
} from 'vuelidate/lib/validators';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import AiToolsMixin from '@motionelements/core/src/components/mixins/ai-tools.mixin.js';
import PredictionMixin from '@/components/mixins/prediction.mixin.js';

export default {
  name: 'StyleTransfer',
  mixins: [AiToolsMixin, PredictionMixin, featureFlagMixin],
  components: {
    ToolImageLayout: () => import('@/components/core/ToolImageLayout.vue'),
    SourceImage: () => import('@/components/tools/SourceImage.vue'),
    DemoSourceImages: () => import('@/components/tools/DemoSourceImages.vue'),
    SelectImage: () => import('@/components/tools/SelectImage.vue'),
    PromptTextarea: () => import('@/components/tools/PromptTextarea.vue'),
    FormCollapseField: () => import('@/components/tools/FormCollapseField.vue'),
  },
  data() {
    return {
      form: {
        model: '',
        image: null,
        styleImage: null,
        prompt: '',
        negativePrompt: '',
        numOutputs: 4,
      },
      prediction: {
        model: '',
        image: null,
        styleImage: null,
        prompt: '',
        negativePrompt: '',
        numOutputs: 4,
      },
      demoImage: null,
      demoImages: [
        {
          labelImage: 'https://static.moele.me/img/studio-ai/style-transfer/asian-women.png?auto=format&w=88',
          value: 'asian-women',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/style-transfer/couple.png?auto=format&w=88',
          value: 'couple',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/style-transfer/women.png?auto=format&w=88',
          value: 'women',
        },
      ],
    };
  },
  validations: {
    form: {
      image: {
        required: required,
      },
      model: {
        required: required,
      },
      prompt: {
        minLength: minLength(10),
        maxLength: maxLength(1000),
      },
      negativePrompt: {
        minLength: minLength(10),
        maxLength: maxLength(1000),
      },
    },
  },
  computed: {
    tool() {
      return this.aiTools.find(({ id }) => id === this.aiToolsIds.STYLE_TRANSFER);
    },
    styles() {
      const styles = [];

      if (this.isFeatureEnabled('studio_ai_style_transfer_custom')) {
        styles.push({
          value: 'style_custom',
          label: this.$t('studio_ai.styles.custom'),
        });
      }

      styles.push(...[
        {
          labelImage: 'https://static.moele.me/img/studio-ai/styles/flash.png?auto=format&w=88',
          value: 'style_glow_flash',
          label: this.$t('studio_ai.styles.flash'),
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/styles/plexus.png?auto=format&w=88',
          value: 'style_plexus',
          label: this.$t('studio_ai.styles.plexus'),
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/styles/colorart.png?auto=format&w=88',
          value: 'style_color_art',
          label: this.$t('studio_ai.styles.colorart'),
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/styles/manga.240804.png?auto=format&w=88',
          value: 'style_manga',
          label: this.$t('studio_ai.styles.manga'),
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/styles/anime.240804.png?auto=format&w=88',
          value: 'style_anime',
          label: this.$t('studio_ai.styles.anime'),
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/styles/neon.240804.png?auto=format&w=88',
          value: 'style_glow_neon',
          label: this.$t('studio_ai.styles.neon'),
        },
      ]);

      return styles;
    },
    demoOutput() {
      if (this.demoImage && this.getImageStyle) {
        const toolId = this.aiToolsIds.STYLE_TRANSFER.replace('_', '-');
        const imagePath = `https://static.moele.me/img/studio-ai/${toolId}/${this.demoImage}/${this.demoImage}_${this.getImageStyle}`;
        return Array(4).fill(imagePath).map((item, index) => {
          if (index === 0) {
            return { preview: { url: `${item}.png?auto=format&w=524` } };
          }
          return { preview: { url: `${item}-${index}.png?auto=format&w=524` } };
        });
      }
      return null;
    },
    getImageStyle() {
      switch (this.form.model) {
        case 'style_glow_flash':
          return 'flash';
        case 'style_plexus':
          return 'plexus';
        case 'style_color_art':
          return 'colorart';
        case 'style_manga':
          return 'manga';
        case 'style_anime':
          return 'anime';
        case 'style_glow_neon':
          return 'neon';
        default:
          return null;
      }
    },
  },
  methods: {
    clearForm() {
      this.form.model = null;
      this.form.image = null;
      this.demoImage = null;
      this.form.styleImage = null;
      this.form.prompt = '';
      this.form.negativePrompt = '';
    },
    setFormFromResponse(response) {
      this.form.model = _.get(response, 'model');
      this.form.image = _.get(response, 'input.image');
      this.form.prompt = _.get(response, 'input.prompt');
      this.form.negativePrompt = _.get(response, 'input.negativePrompt');
      this.prediction.model = _.get(response, 'model');
      this.prediction.image = _.get(response, 'input.image');
      this.prediction.prompt = _.get(response, 'input.prompt');
      this.prediction.negativePrompt = _.get(response, 'input.negativePrompt');
    },
  },
};
